import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Link } from '../../Link/Link.es.js';
import ButtonTooltip from '../Button.Tooltip.es.js';

const LinkButton = ({ className, disabled = false, iconOnly = false, intent, label, size = 'base', variant, ...rest })=>{
    const linkProps = {
        ...rest,
        disabled,
        label,
        className: classNames('cb-button', size, variant, intent, className, {
            disabled,
            'icon-only': iconOnly
        })
    };
    return jsx(ButtonTooltip, {
        iconOnly: iconOnly,
        label: label,
        variant: variant,
        children: jsx(Link, {
            ...linkProps
        })
    });
};
LinkButton.displayName = 'Button.Link';

export { LinkButton as default };
//# sourceMappingURL=Link.es.js.map
